import { XIColors } from '@inmoment/the-kitchen';
import styled from 'styled-components';

export interface CodeBlockWrapperProps {
  hasBorder?: boolean;
  hasTopRadius?: boolean;
  hasPadding?: boolean;
}
export const CodeBlockWrapper = styled.div`
  box-sizing: border-box;
  width: 100%;
  background: ${XIColors.white.primary};
  ${({ hasBorder = true }: CodeBlockWrapperProps) => (hasBorder ? `border: 1px solid ${XIColors.grey.light[80]};` : '')}
  ${({ hasTopRadius = true }: CodeBlockWrapperProps) =>
    hasTopRadius
      ? 'border-radius: 6px;'
      : `border-bottom-left-radius: 6px; 
  border-bottom-right-radius: 6px;`}
  overflow: auto;
  ${({ hasPadding = true }: CodeBlockWrapperProps) => (hasPadding ? 'padding: 24px;' : '')}
  resize: none;
  &:focus {
    outline: none;
  }
`;
